var map = {
	"./Boost.png": 158,
	"./Clinique.png": 159,
	"./DoctorsBest.png": 160,
	"./Dove.png": 161,
	"./GardenOfLife.png": 162,
	"./HeadAndShoulders.png": 163,
	"./HerbalEssences.png": 164,
	"./NatureMade.png": 165,
	"./Neutrogena.png": 166,
	"./Olay.png": 167,
	"./Pantene.png": 168,
	"./Ponds.png": 169,
	"./SpringValley.png": 170,
	"./Suave.png": 171,
	"./placeholder.png": 172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 373;